
import * as Sentry from "@sentry/react";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import { LocationProvider } from "./contexts/locationContext";
import { AppProvider } from "./userDashboard/app/providers";
import { UserProvider } from "./userDashboard/contexts/userContext";
import { SnackbarUtilsConfigurator } from "./utils/snackbarUtils";


// Initialize Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "", // Reads from .env
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1, // Capture all traces
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
  release: process.env.REACT_APP_SENTRY_RELEASE || "your-app@1.0.0",
  replaysSessionSampleRate: 0.1, // Capture 10% of sessions
  replaysOnErrorSampleRate: 1, // Capture 100% of error sessions,
  tracePropagationTargets: [
    // "localhost",
    // "https://saca.vtawkercel.app/",
    "sacafootball.com",
  ],
});

// Wrap App with Sentry Error Boundary
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: <h1>Something went wrong. Please try again later.</h1>,
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <SnackbarUtilsConfigurator />
      <UserProvider>
        <LocationProvider>
          <AppProvider>
            <Router>
              <SentryApp /> {/* Wrapped App with Sentry error boundary */}
            </Router>
          </AppProvider>
        </LocationProvider>
      </UserProvider>
    </SnackbarProvider>
  </React.StrictMode>
);
